import React from "react";

export default function Loader() {
  return (
    <div className="loader-wrapper">
      {/* <div className="spinner-border text-primary" style={{ width: '4rem', height: '4rem' }} role="status"> */}
      <div
        className="spinner-border"
        style={{ width: "4rem", height: "4rem", color: "#011936" }}
        role="status"
      >
        <span className="visually-hidden">Loading...</span>
      </div>
    </div>
  );
}
